import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
const API_URL = environment.apiUrl;

@Injectable({
    providedIn: 'root'
})
export class ClubService {
    constructor(private http: HttpClient) { }

    getClubList(query): Observable<any> {
        return this.http.get(API_URL + "club?" + query);
    }
    getClubWithoutAuthList(query): Observable<any> {
        return this.http.get(API_URL + "club/v1" + query);
    }

    getClubDetails(id): Observable<any> {
        return this.http.get(API_URL + "club/" + id);
    }

    updateClub(id, clubData): Observable<any> {
        return this.http.put(API_URL + 'club/' + id, clubData);
    }

    addClub(clubData): Observable<any> {
        return this.http.post(API_URL + 'club', clubData);
    }

    getAllClub(querystring): Observable<any> {
        return this.http.get(API_URL + "club/all/?" + querystring);
    }
    getAllDecendants(querystring): Observable<any> {
        return this.http.get(API_URL + "club/descendants/?" + querystring);
    }

    searchClubDetails(querystring): Observable<any> {
        return this.http.get(API_URL + 'club/?' + querystring);
    }

}
